<template>
    <div>
        <link href="https://img2.233.com/wx/union/pc/fine/category/css/cfe.css" rel="stylesheet" type="text/css">
        <div class="wx-header-cont" id="wx-header-cont"> 
        <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
        <div class="wx-header-container">
            <div class="fl-box">
          <h1 class="logo"> <a href="/"><img  :src="logo" > </a> </h1>
            <div class="line"></div>
            <div class="wx-subject">
                <h2>一级消防工程师</h2>
                <i class="dropdown-arrow"></i>
                <div class="subject-list">
                        <a href="./#/jianli">监理工程师</a>
                        <a href="./#/aq">安全工程师</a>
                        <a href="./#/cfe">一级消防工程师</a>
                        <a href="./#/zaojia">造价工程师</a>
                        <a href="./#/jzs1">一级建造师</a>
                        <a href="./#/jzs2">二级建造师</a>
                        <a href="./#/zjy">二级造价工程师</a>
                        <a href="./#/zjxfy">消防设施操作员</a>
                </div>
            </div>
            <div class="head-area  text-gry6 font14 fl m-t-10"  style="display: none;"> 当前地区
                <p class="m-l-15  bg-white fr "><em class="now-area p-0-20">全国版</em><a href="" class="more-area p-0-10">更多地区 </a></p>
                <div class="area_list">
                <ul>
                    <li><a href="/tegang/guojia/#tgtc">全国</a></li>
                    <li><a href="/tegang/shanxi1/#tgtc">陕西</a></li>
                    <li><a href="/tegang/hebei/#tgtc">河北</a></li>
                    <li><a href="/tegang/henan/">河南</a></li>
                    <li><a href="/tegang/sichuan/#tgtc">四川</a></li>
                    <li><a href="/tegang/jiangxi/#tgtc">江西</a></li>
                    <li><a href="/tegang/yunnan/#tgtc">云南</a></li>
                    <li><a href="/tegang/heilongjiang/#tgtc">黑龙江</a></li>
                    <li><a href="/tegang/chongqing/#tgtc">重庆</a></li>
                    <li><a href="/tegang/hubei/#tgtc">湖北</a></li>
                </ul>
                </div>
            </div>
            </div>
            <div class="fr-box"> 
                <!--未登录 -->
                <div class="personal-no" v-if="!isLogin">
                    <p><a target="_blank" :href="'/uc/login?redirecturl='+href" class="red">登录</a>|<a target="_blank" :href="'/uc/register?redirecturl='+href">注册</a></p>
                </div>
                <div class="personal" v-else>
                            <a href="javascript:;" class="pic"><img :src="logoSrc" ><i class="dropdown-arrow"></i></a>
                            <div class="pop-personal">
                                <a href="javascript:" @click="loginout()"><i class="icon"></i><span class="txt">退出</span></a>
                            </div>
                </div>
                <div class="classify"> 
                    <a class="classify-list" href="/shopping/cart" target="_blank" title="购课车">
                    <p class="icon shopping"></p>
                    </a> </div>
                <div v-if="kefu.length>0" class="wx-telephone">
                    <p class="txt1">客服热线</p>
                    <p class="txt2">{{kefu}}</p>
                </div>
            </div>
        </div>
        <div class="clear"></div>
        </div>
        <!--banner-->
        <div class="bg-black"> 
        <!--01banner-->
        <Banner imgUrl="https://img2.233.com/wx/union/pc/fine/category/img/cfe/banner01.jpg"></Banner>
        <!--01banner 结束--> 
        <!---02试听区域--->
        <div class="video clearfix">
            <div class="video-layout">
            <div class="subject-tabBox clearfix" >
                <ul class="sub-tabL clearfix">
                <li class="line" @click="changeCourseIndex(i)" v-for="(v,i) in courses.slice(0,4)" :key="i">
                    <a href="javascript: void(0)"  :class="i==courseIndex?'hover':''">{{v.name}}</a>
                </li>
                </ul>
                <div class="Rselect-box" @mouseover="changeIsHoverCourse(true)" @mouseout="changeIsHoverCourse(false)" >
                </div>
            </div>
            <myvideo   :isLogin="isLogin"  :allLoginPlayFlag="allLoginPlayFlag"  :unionId="unionId" :classEname="'cfe'" :logo="logo" :myClassId="courses[courseIndex].myClassId"></myvideo>
            </div>
            <div class="video-bottom"></div>
        </div>
        <!---02试听区域END---> 
        </div>
        <!--03原高级平台班级对比-->
        <banjiduibi :calssName="'一级消防工程师'" :classEName="'cfe'"></banjiduibi>
        <!--03原高级平台班级对比 end--> 
            
        <!--04全部班级表格-->
        <quanbubanji :classEname="'cfe'"></quanbubanji>
        <!--04全部班级表格 end--> 

        <!--3D教学动画-->
        <div class="dhjx_model" id="dhjx">
            <!--标题-->
        <div class="title school-one">
            <h2 class="h2-txt">
                <p>
                <em>01</em>
                <strong>
                    
                    <a name="sztd"></a>3D动画教学</strong>
                </p>
                <span class="h2span1">体验真实模型工作机制，理解快人一步</span>
            </h2>

            SCHOOL
            </div>
        <!--标题 end-->
            
        <div class="dhjx_box clearfix">
        
        
        <div class="dhjx_wn_lt2">
            <i class="dhjx_zs"></i>
            <p><i class="zd_wn">通过3D技术</i>还原消防实景，体验真实模型工作机制，理解快人一步
        </p>
            <div class="pk-icon_02"><a href="javascript:" @click="scroll(900)">立即听课</a></div> 
            
            
        </div>  
        <div class="dhjx_wn_rt2">
        </div>
        
        
        </div>
        </div>
        <!--3D教学动画 end-->
        <!--2教学创新-->
        <div class="wx-course light-blue-course">
            <div class="wx-mian clearfix">
            <!--标题-->
            <div class="title school-three">
                <h2 class="h2-txt">
                <p>
                    <em>02</em>
                    <strong>
                    <b class="h2-b4"></b>
                    <a name="jxcx"></a>教学特色</strong>
                </p>

                <span class="h2span2">2020新课程打造业内特色教学模式</span>
                </h2>
                SCHOOL
            </div>
            <!--标题 end-->
            


        <div class="dhjx_box clearfix">

        <div class="dhjx_wn_lt">
            <i class="dhjx_zs"></i>
            <p><i class="zd_wn">特设思维导图直播班</i>
        <br>思维导图直播班根据思维导图讲解知识点， 帮助快速找到记忆技巧。 
        </p>
            <div class="pk-icon_01"><a  href="javascript:" @click="scroll(900)">立即听课</a></div> 
        </div>  
        <div class="dhjx_wn_rt">
        </div>
        </div></div>
        </div>
        <!--2教学创新 end-->
        <!--师资团队-->
        <div class="wx-course dark-ls-course">
            <!--标题-->
            <div class="title school-one">
            <h2 class="h2-txt">
                <p>
                <em>03</em>
                <strong>
                    <b class="h2-b7"></b>
                    <a name="sztd"></a>师资团队</strong>
                </p>
                <span class="h2span1">集结业内老师，“大神”黄明峰领衔教学</span>
            </h2>
            SCHOOL
            </div>
            <!--标题 end-->
            <div class="m-teacher">
                <div class="wx-mian wx-mian-teacher" data-type="{cs1: 'teacher-li',tlist: '.teacher-ul li',clist: '.teacher-yr'}
                        " node-type="menu-tab">
                    <div class="dei"></div>
                    <div class="teacher-team">
                        <h5 class="h5-teacher">
                            <b>消防师资团队</b>
                            <span>TEACHER TEAM</span>
                            <i class="teacher-ione"></i>
                            <i class="teacher-itwo">集结业内老师，“大神”黄明峰领衔教学</i>
                        </h5>
                        <ul class="teacher-ul">
                            <li :class="teacherIndex==0?'teacher-li':''" @mouseover="changeTeacherIndex(0)">
                                <img src="https://img2.233.com/wx/union/pc/fine/category/img/cfe/t-teacher1.jpg"  alt="" data-lzled="true">
                            </li>
                            <li :class="teacherIndex==1?'teacher-li':''" @mouseover="changeTeacherIndex(1)">
                                <img src="https://img2.233.com/wx/union/pc/fine/category/img/cfe/t-teacher2.jpg" alt="" data-lzled="true">
                            </li>
                            <li :class="teacherIndex==2?'teacher-li':''" @mouseover="changeTeacherIndex(2)">
                                <img src="https://img2.233.com/wx/union/pc/fine/category/img/cfe/t-teacher3.jpg" alt="" data-lzled="true">
                            </li>
                            <li :class="teacherIndex==3?'teacher-li':''" @mouseover="changeTeacherIndex(3)">
                                <img src="https://img2.233.com/wx/union/pc/fine/category/img/cfe/t-teacher4.jpg" alt="" data-lzled="true">
                            </li>
                            <li :class="teacherIndex==4?'teacher-li':''" @mouseover="changeTeacherIndex(4)">
                                <img src="https://img2.233.com/wx/union/pc/fine/category/img/cfe/t-teacher5.jpg" alt="" data-lzled="true">
                            </li>
                            <li :class="teacherIndex==5?'teacher-li':''" @mouseover="changeTeacherIndex(5)">
                                <img src="https://img2.233.com/wx/union/pc/fine/category/img/cfe/t-teacher6.jpg" alt="" data-lzled="true">
                            </li>
                        </ul>
                    </div>
                    <div class="teacher-yr" v-for="(v,i) in teachers" :key="i" v-show="teacherIndex==i">
                        <div class="kqquan"></div>
                        <div class="teacher-tops clearfix" >
                            <div class="teacher-yr-img fl">
                                <img :src="'https://img2.233.com/wx/union/pc/fine/category/img/cfe/'+v.img"  alt="" data-lzled="true">
                            </div>
                            <div class="teaching-box fl">
                            <div class="teaching-age">
                                <h5 class="teaching-h5">{{v.name}}</h5>
                                <p v-html="v.jieshao">
                                </p>
                            </div>
                            <h5 class="speaker-h5">主讲科目</h5>
                            <ul class="teaching-speaker">
                                <li v-for="(vv,ii) in v.zhujiang" :key="ii">
                                    <span>{{vv}}</span>
                                </li>
                            </ul>
                            </div>
                        </div>
                        <div class="teaching-evaluation">
                            <h5 class="speaker-h5">专业背景</h5>
                            <p>{{v.zhuanye}}</p>
                        </div>
                        <div class="teaching-evaluation teaching-evaluations">
                            <h5 class="speaker-h5">学员评价</h5>
                            <p>{{v.pingjia}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--师资团队 end-->
        <!--智能题库模块-->
        <div class="wx-course zhinneg_md">
            <div class="wx-mian clearfix"> 
                    <!--标题-->
                <div class="title school-three">
                <h2 class="h2-txt">
                <p>
                    <em>04</em>
                    <strong>
                    
                    <a name="jxcx"></a>智能题库</strong>
                </p>

                <span class="h2span2">配套赠送题库VIP会员，专业智能，高效提分</span>
                </h2>
                SCHOOL
                </div>
                    <!--标题 end-->
                    <div class="zhineng_md_all clearfix"> 
                    
                    
                        <div class="zntk_md_left">
                                <h4>品质过硬</h4>
                                <ul class="znmd_left_ul clearfix">
                                    <li>
                                    <div class="znmk_md1 clearfix">
                                            <i class="znmd_icon znmd_img_1"></i>
                                            <div class="znmd_li_title">
                                                <h5>专业解析</h5>
                                                <p>每道题<font class="ft_bold">配有专业答案解析</font><br>
        解密题目背后的考点逻辑</p>
                                            </div>
                                    </div>
                                    <a>注：付费学员专享100%章节题量</a>
                                    </li>
                                    
                                    <li>
                                    <div class="znmk_md1 clearfix">
                                            <i class="znmd_icon znmd_img_2"></i>
                                            <div class="znmd_li_title">
                                                <h5>助教答疑</h5>
                                                <p>每道题<font class="ft_bold">专业助教答疑服务</font><br>
        做题不留任何疑问
        </p>
                                            </div>
                                    </div>
                                    <a class="znmd_a_bg2">注：付费学员专享</a>
                                    </li>
                                    
                                    <li class="bottom_pt18">
                                    <div class="znmk_md1 clearfix">
                                            <i class="znmd_icon znmd_img_3"></i>
                                            <div class="znmd_li_title">
                                                <h5>模考大赛</h5>
                                                <p>万名考生同场闯关做题<br>
        <font class="ft_bold">并配套名师直播讲题</font>
        </p>
                                            </div>
                                    </div>
                                    
                                    </li>
                                    
                                    <li class="bottom_pt18">
                                    <div class="znmk_md1 clearfix">
                                            <i class="znmd_icon znmd_img_4"></i>
                                            <div class="znmd_li_title">
                                                <h5>视频解析</h5>
                                                <p>重难点考题配套视频解析<br>
        <font class="ft_bold">授课名师分析答题“套路”</font>
        </p>
                                            </div>
                                    </div>
                                    
                                    </li>
                                    
                                    <li>
                                    <div class="znmk_md1 clearfix">
                                            <i class="znmd_icon znmd_img_5"></i>
                                            <div class="znmd_li_title">
                                                <h5>2套考前点题</h5>
                                                <p>考前10天上线2套点题<br><font class="ft_bold">专业师资高效预测考点</font></p>
                                            </div>
                                    </div>
                                    <a class="znmd_a_bg2">注：付费学员专享</a>
                                    </li>
                                </ul>
                        </div>
                            
                        <div class="zntk_md_right">
                                    <h4>智能系统</h4>  
                                <ul class="znmd_right_ul clearfix">
                                    <li class="znmd_rli    znmd_rli_bg1">
                                        <div class="znmdli_right_title">
                                                <h5>云计算</h5>
                                                <p>数百万用户高频错题<br><font class="ft_bold2">帮助避开常见失分点</font></p>
                                            </div> 
                                    </li>
                                    
                                    <li class="znmd_rli  color_blue   znmd_rli_bg2">
                                        <div class="znmdli_right_title">
                                                <h5>错题归纳</h5>
                                                <p>错题按章节和题型归类<br><font class="ft_bold2">智能汇总个人薄弱考点</font></p>
                                            </div> 
                                    </li>
                                    
                            <li class="znmd_rli  color_blue   znmd_rli_bg3">
                                        <div class="znmdli_right_title">
                                                <h5>大数据提分</h5>
                                                <p>结合考情，分析章节分值<br><font class="ft_bold2">大数据预判考点，精准提分</font></p>
                                            </div> 
                                    </li>
                                    
                                    
                                    <li class="znmd_rli    znmd_rli_bg4">
                                        <div class="znmdli_right_title">
                                                <h5>智能评分</h5>
                                                <p><font class="ft_bold2">系统根据做题数据智能评分</font><br>科学评测做题水准</p>
                                            </div> 
                                    </li>
                                    
                                    
                                    <li class="znmd_rli    znmd_rli_bg5">
                                        <div class="znmdli_right_title">
                                                <h5>离线做题</h5>
                                                <p>网校APP支持套题下载<br><font class="ft_bold2">随时随地免流量刷题</font></p>
                                            </div> 
                                    </li>
                                    
                                                            
                                </ul>     
                        
                        </div> 
                            
                    </div>
                </div>
        </div>
        <!--智能题库模块 end-->
        <!--5复习攻略-->
        <div class="wx-course gray2-course">
            <div class="wx-mian wx-raiders">
            <!--标题-->
            <div class="title school-three">
                <h2 class="h2-txt">
                <p>
                    <em>05</em>
                    <strong>
                    <b class="h2-b6"></b>
                    <a name="fxgl"></a>复习攻略</strong>
                </p>
                <span class="h2span2">科学授课体系，从小白逆袭为达人</span>
                </h2>
                SCHOOL
            </div>
            <!--标题 end-->

        <div class="review">
            <ul class="raiders-step fl">
                <li :class="fuxigonglueIndex==0?'raiders-step-selected':''" @click="fuxigonglueIndex=0"><em></em><p>基础阶段<br><i>全面锁定教材考点</i></p></li>
                <li :class="fuxigonglueIndex==1?'raiders-step-selected':''" @click="fuxigonglueIndex=1"><em></em><p>强化阶段<br><i>详细梳理，化繁为简</i></p></li>
                <li :class="fuxigonglueIndex==2?'raiders-step-selected':''" @click="fuxigonglueIndex=2"><em></em><p>冲刺阶段<br><i>强化巩固重要考点</i></p></li>
                <li :class="fuxigonglueIndex==3?'raiders-step-selected':''" @click="fuxigonglueIndex=3"><em></em><p>考前阶段<br><i>查漏补缺临考提分</i></p></li>
            </ul>
            
            <div class="raiders-bj fl" v-show="fuxigonglueIndex==0">
                <div class="raiders-list fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-one">01</em><span>教材精讲班</span><i>实务+综合</i></dt>
                        <dd>根据教材或考试大纲，全面讲解各章节知识点，帮助考生锁定80%以上考点，属于基础阶段班级。</dd>
                        <dd></dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">全面讲解教材知识点</span></li>
                        <li><b>学习方法<i></i></b><span>先通读教材，再学习课程（可学3遍左右）</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">31-57小时/科（2个老师总课时）</span></li>
                    </ul>
                </div>
                <div class="raiders-list raiders-list-top fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-two">02</em><span>实操班</span></dt>
                        <dd>运用图文结合的方式讲解现场实践操作，帮助非专业考生强化实操弱项，属于基础阶段班级。</dd>
                        <dd></dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">对消防系统实践拆分</span></li>
                        <li><b>学习方法<i></i></b><span>结合课程，对教材相关系统建立认识</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">约22小时</span></li>
                    </ul>
                </div>
                <div class="raiders-list raiders-list-top fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-three">03</em><span>规范班</span></dt>
                        <dd>对消防涉及的规范进行详细梳理，化繁为简，系统的展现考试中规范运用情况，属于强化阶段班级。</dd>
                        <dd> </dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">系统讲解八大规范</span></li>
                        <li><b>学习方法<i></i></b><span>根据课程学规范，再学教材事半功倍</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">约50小时（5个规范总课时）</span></li>
                    </ul>
                </div>
                <div class="raiders-score-r">
                    <p class="score-top">基础阶段帮你<br>攻克<br><b>85%以上</b><span>知识点</span></p>
                    <p class="score-bottom"><i class="score-jian"></i><i class="score-dian"></i><span>先拿<br><b>30</b>分</span></p>
                </div>
            </div>
            
            <div class="raiders-bj fl" v-show="fuxigonglueIndex==1" >
                <div class="raiders-list fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-four">04</em><span>习题班</span></dt>
                        <dd>针对性讲解具有代表性的典型习题，分析出题方向，总结各题型答题技巧，属于强化阶段班级。</dd>
                        <dd></dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">详解经典考题</span></li>
                        <li><b>学习方法<i></i></b><span>先在线模考，再学视频课程</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">4-16小时/科</span></li>
                    </ul>
                </div>
                <div class="raiders-list raiders-list-top fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-five">05</em><span>思维导图直播班</span></dt>
                        <dd>美女程一波老师通过直播形式讲解思维导图考点，帮助考生更好记忆，属于基础阶段班级。</dd>
                        <dd></dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">帮助更好记忆考点</span></li>
                        <li><b>学习方法<i></i></b><span>结合课程，建立教材思维框架</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">约20小时</span></li>
                    </ul>
                </div>
                <div class="raiders-list raiders-list-top fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-six">06</em><span>三合一班</span></dt>
                        <dd>将3科知识点进行整合串联，形成整体框架梳理记忆，便于案例知识点的运用理解，属于强化阶段班级。</dd>
                        <dd> </dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">将3科知识点进行整合串联</span></li>
                        <li><b>学习方法<i></i></b><span>掌握3科教材内容，再学三合一</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">约70小时（2个老师总课时）</span></li>
                    </ul>
                </div>
                <div class="raiders-score-r">
                    <p class="score-top">强化阶段帮你<br>攻克<br><b>80%</b><span>考点</span></p>
                    <p class="score-bottom score-bottom2"><i class="score-jian"></i><i class="score-dian"></i><span>再提<br><b>35</b>分</span></p>
                </div>
            </div>
            
            <div class="raiders-bj fl" v-show="fuxigonglueIndex==2">
                <div class="raiders-list fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-seven">07</em><span>教材精讲班</span><i>案例</i></dt>
                        <dd>根据教材或考试大纲，全面讲解各章节知识点，帮助考生锁定90%考点，属于冲刺阶段班级。</dd>
                        <dd></dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">对案例知识点汇总讲解</span></li>
                        <li><b>学习方法<i></i></b><span>前期可以不看，熟悉固定两科知识点后再学</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">约65小时（2个老师总课时）</span></li>
                    </ul>
                </div>
                <div class="raiders-list raiders-list-top fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-eight">08</em><span>冲刺班</span></dt>
                        <dd>系统讲解各章节核心考点，帮助考生理清考点关联性，突破重难点，属于冲刺阶段班级。</dd>
                        <dd></dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">突破各科高频考点</span></li>
                        <li><b>学习方法<i></i></b><span>结合教材，学习各章内容</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">3-12小时/科</span></li>
                    </ul>
                </div>
                <div class="raiders-list raiders-list-top fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-nine">09</em><span>规范拔高班</span></dt>
                        <dd>针对主要规范进行高层次的拔高讲解，解决后期学习规范容易掉“坑”的问题。</dd>
                        <dd></dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">掌握规范考核内容</span></li>
                        <li><b>学习方法<i></i></b><span>根据课程进行内容总结</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">约30小时</span></li>
                    </ul>
                </div>
                <div class="raiders-score-r">
                    <p class="score-top">冲刺阶段帮你<br>巩固<br><b>85%</b><span>考点</span></p>
                    <p class="score-bottom score-bottom3"><i class="score-jian"></i><i class="score-dian"></i><span>再得<br><b>45</b>分</span></p>
                </div>
            </div>
            
            <div class="raiders-bj fl" v-show="fuxigonglueIndex==3">
                <div class="raiders-list fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-ten">10</em><span>考题突击班</span></dt>
                        <dd>讲解2套高含金量突击试题，并配套电子版在线试题，预测考试方向及趋势，属于考前阶段班级。</dd>
                        <dd></dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">分析2套突击试题</span></li>
                        <li><b>学习方法<i></i></b><span>先模考测试，再学习视频解析</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">2-5小时/科</span></li>
                    </ul>
                </div>
                <div class="raiders-list raiders-list-top fl">
                    <dl class="raiders-list-dl fl">
                        <dt><b></b><em class="digital-eleven">11</em><span>直播班</span></dt>
                        <dd>通过直播的形式，在不同备考阶段进行直播密训，为学员串讲考点和答疑。</dd>
                        <dd> </dd>
                    </dl>
                    <ul class="raiders-list-ul fl"> 
                        <li><b>学习作用<i></i></b><span class="raiders-red">考前串讲核心考点</span></li>
                        <li><b>学习方法<i></i></b><span>根据直播总结，查漏补缺</span></li>
                        <li><b>学习时长<i></i></b><span class="raiders-gray">2小时/科</span></li>
                    </ul>
                </div>
                <div class="raiders-score-r">
                    <p class="score-top">考前阶段，专业指导；<br>考点串讲，直播特训；<br><span class="score-top-span">预测考点</span></p>
                    <p class="score-bottom score-bottom4"><i class="score-jian"></i><i class="score-dian"></i><span>稳拿<br><b>75</b>分</span></p>
                </div>
            </div>
        </div>
    </div>
        </div>
        <!--5复习攻略 end-->
        <!--06套用官网内容  end-------------> 
        <!--05服务特色标题-->
        <div class="main-title f-tac m-b-30 p-t-50" >
        <p class="font-bg">CHARACTERISTIC</p>
        <h2 class="font44 fb">选择我们的<em class="text-red fb">四大理由</em></h2>
        <p class="font17 text-gry-6 lh2">服务保障，学习无忧，通关指日可待</p>
        </div>
        <div class="fuwu-bg ">
        <div class="fuwu-content">
            <div class="fuwu-box">
            <ul class="clearfix m-b-20">
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">1</span>课程品质高</h4>
                <p class="font15 lh2 p-15">课程专业的教研团队精心打造，<em class="text-red fb">每个课程均经过20+次以上迭代</em>。</p>
                </li>
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">2</span>老师实力强</h4>
                <p class="font15 lh2 p-15">网校执行严格的<em class="text-red fb">师资淘汰制，由购课学员评分</em>，努力建设零差评老师团队。</p>
                </li>
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">3</span>学习服务优</h4>
                <p class="font15 lh2 p-15">您在学习课程中遇到任何问题，可在线提问，专业老师<em class="text-red fb">24小时内为您答疑解惑</em>。</p>
                </li>
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">4</span>售后服务好</h4>
                <p class="font15 lh2 p-15">部分套餐课程享<em class="text-red fb">超长有效期</em>，课程有效期内考试<em class="text-red fb">不过免费重学</em>保障。</p>
                </li>
            </ul>
            </div>
            
            
        </div>
        </div>
        <!--05服务特色 end--> 
    </div>
</template>
<script>
import myvideo from '@/components/myvideo'
import banjiduibi from '@/components/banjiduibi'
import quanbubanji from '@/components/quanbubanji'
import { getMemberPicpath } from '@/request/request.js'
export default {
  name: 'App',
  components: {
    banjiduibi,
    quanbubanji,
    myvideo
  },  
  data() {
    return {
        fuxigonglueIndex:0,
      laoshiindex:0,
      isLogin:false,
      logoSrc:"",
      allLoginPlayFlag:false,
      unionId:"",
      kefu:"",
      logo:"",
      href:"",
      courses:[
        {name:'消防安全技术综合能力',myClassId:31209},
        {name:'消防安全技术实务',myClassId:31208},
        {name:'消防安全案例分析',myClassId:31210},
      ],
      courseIndex:0,
      isHoverCourse:false,
      teachers:[
            {                  
                img:"t-teacher-da1.jpg",
                name:"黄明峰老师",
                jieshao:'<span class="jz-name"><em>13</em>年建筑类教学经验</span><span><em>5</em>年消防教学经验</span>',
                zhujiang:["技术实务","综合能力","案例分析"],
                zhuanye:"网校独家主讲3科，一级消防工程师，一级建造师，造价工程师，建设工程造价协会理事",
                pingjia:"黄老师是消防培训界可以封“神”的人物。讲课通俗易懂，生动形象而不照本宣科，太过瘾了。"
            },
            {
                img:"t-teacher-da2.jpg",
                name:"李兴伟老师",
                jieshao:'<span class="jz-name"><em>6</em>年建筑类教学经验</span><span><em>4</em>年消防教学经验</span>',
                zhujiang:["防排烟规范"],
                zhuanye:"网校独家签约老师，一级消防工程师，一级建造师，二级建造师",
                pingjia:"李老师，牛人也！可以把知识点有效串起来，那些难记的数字也好记忆了。"
            },
            {
                img:"t-teacher-da3.jpg",
                name:"胡云老师",
                jieshao:'<span class="jz-name"><em>10</em>年建筑类教学经验</span><span><em>5</em>年消防教学经验</span>',
                zhujiang:["技术实务"],
                zhuanye:"网校独家签约老师，高级工程师，一级消防工程师，一级建造师",
                pingjia:"胡老师的课程相当好，必须给赞。零基础学员听了也很透彻，考试信心倍增，争取通过考试拿证。"
            },
            {
                img:"t-teacher-da4.jpg",
                name:"姜宁老师",
                jieshao:'<span>从事建筑防火审核及验收工作30年</span>',
                zhujiang:["防排烟规范班 "],
                zhuanye:"消防专家、高级工程师、特殊津贴获得者及技术人才一等奖",
                pingjia:"姜老师授课风格深入浅出，实践经验丰富，专业性强，真正属于注册消防工程师行业的”泰斗式人物”。"
            },
            {
                img:"t-teacher-da5.jpg",
                name:"葛磊老师", 
                jieshao:'<span class="jz-name"><em>10</em>年建筑类教学经验</span><span><em>4</em>年消防教学经验</span>',
                zhujiang:["综合能力"],
                zhuanye:"硕士，一级消防工程师，消防领域高级专业培训讲师",
                pingjia:'葛老师讲课很有特点，逻辑性好，总结精准，生动易于理解！十多年的消防实践经验，是行业内人人追捧的"大师"。'
            },
            {
                img:"t-teacher-da6.jpg",
                name:"刘谛老师",
                jieshao:'<span class="jz-name"><em>6</em>年建筑类教学经验</span><span><em>4</em>年消防教学经验</span>',
                zhujiang:["三合一班","案例分析"],
                zhuanye:"网校独家签约老师，一级消防工程师，一级建造师",
                pingjia:"刘老师讲得很有深度，研究得很透彻，信息量很大，一节课顶五节课，听了让人豁然开朗。"
            },
      ],
      teacherIndex:0,
      tixiIndex:0,
    };
  },
  created(){
    this.href=encodeURIComponent(window.location.href);
    var config=JSON.parse(sessionStorage.getItem(window.location.host+"puconfig"));
    if(config.KefuTelList.length>0){
      this.kefu=config.KefuTelList[0].KefuNumber;
    }
    this.unionId=config.UnionId
    this.logo=config.UnionLogo;
    this.allLoginPlayFlag=config.AllLoginPlayFlag;
    var token = localStorage.getItem("usertoken");
    if(token!=undefined){
        this.isLogin=true;
        getMemberPicpath({},(res)=>{
            this.logoSrc=res;
        });
    }else{
        var interval= setInterval(() => {
        token = localStorage.getItem("usertoken");
        if(token!=undefined){
          this.isLogin=true;
          getMemberPicpath({},(res)=>{
            this.logoSrc=res;
          });
          clearInterval(interval);
        }
      }, 200);
    }
  },
  methods:{
      loginout(){
          this.isLogin=false;
          this.logoSrc="";
          localStorage.removeItem("usertoken");
      },
      scroll(num){
        document.documentElement.scrollTop=num;
      },
     changeCourseIndex(i){
       this.courseIndex=i;
     },
    changeIsHoverCourse(flag){
      this.isHoverCourse=flag;
    },
    changehoverindex(i){
      this.hoverindex=i;
    },
    changeTeacherIndex(i){
      this.teacherIndex=i;
    },
    changeTixiIndex(i){
        this.tixiIndex=i;
    }
  },
}
</script>